import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "appearance", "size", "action"];
import React, { forwardRef } from 'react';
import system from '../../system';
import Base, { SYSTEM_PROPS } from './Base';
import styles from './index.module.scss';
var BrandedHeading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      appearance = _ref.appearance,
      size = _ref.size,
      action = _ref.action,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  return /*#__PURE__*/React.createElement(Base, _extends({
    ref: ref,
    className: className,
    style: style,
    as: as,
    styles: styles,
    appearance: appearance,
    size: size,
    action: action
  }, rest));
});
BrandedHeading.displayName = 'BrandedHeading';
BrandedHeading.identifier = BrandedHeading.displayName;
BrandedHeading.clonableProps = SYSTEM_PROPS;
BrandedHeading.defaultProps = {
  appearance: 'primary',
  as: 'h1',
  size: 'large'
};
export default BrandedHeading;